import React from 'react';
import styles from './ActionText.module.scss';
import clsx from 'clsx';

type OwnProps = {
  text: string;
  onClickHandler?: () => void;
  disabled?: boolean;
  containerClassName?: string;
  testId?: string;
};

export const NegativeActionText = (props: OwnProps) => {
  return (
    <div
      aria-disabled={props.disabled}
      className={clsx(styles.negativeActionText, props.containerClassName)}
      onClick={props.onClickHandler}
      data-test-id={props.testId}
    >
      {props.text}
    </div>
  );
};
